var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtectionPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 332.578,
    height: 332.578,
    viewBox: "0 0 332.578 332.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#086eb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1eaaf1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2365",
    x: 9.669,
    y: 39.903,
    width: 313.237,
    height: 236.477,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3625",
    "data-name": "Group 3625",
    transform: "translate(-118.917 -208.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M166.289,0A166.289,166.289,0,1,1,0,166.289,166.289,166.289,0,0,1,166.289,0Z",
    transform: "translate(118.917 208.416)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2293",
    "data-name": "Group 2293",
    transform: "translate(137.585 260.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2292",
    "data-name": "Group 2292",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1434",
    "data-name": "Group 1434",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1433",
    "data-name": "Group 1433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1432",
    "data-name": "Group 1432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    "data-name": "Group 1431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1430",
    "data-name": "Group 1430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1417",
    "data-name": "Group 1417"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -18.67, -51.9)",
    filter: "url(#Path_2365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2365-2",
    "data-name": "Path 2365",
    d: "M.325,0H294.911a.325.325,0,0,1,.325.325V218.151a.325.325,0,0,1-.325.325H.325A.325.325,0,0,1,0,218.151V.325A.325.325,0,0,1,.325,0Z",
    transform: "translate(18.67 51.9)",
    fill: "#b5b9bf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M.325,0H271.292a.325.325,0,0,1,.325.325v188.3a.325.325,0,0,1-.325.325H.325A.325.325,0,0,1,0,188.627V.325A.325.325,0,0,1,.325,0Z",
    transform: "translate(11.809 11.81)",
    fill: "#2f2e40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2061",
    "data-name": "Group 2061",
    transform: "translate(153.824 39.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2059",
    "data-name": "Group 2059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M100.845-55.276H85.963v-13.94c0-16.024-12.52-28.984-27.986-28.984S29.991-85.233,29.991-69.215v13.94H15.11c-4.368,0-7.911,3.182-7.911,7.214l.471,60.295c0,4.524,3.072,8.193,6.965,8.193H101.2c3.9,0,6.965-3.669,6.965-8.193l.471-60.295c.125-4.032-3.418-7.214-7.787-7.214Zm-30.348,0H45.463v-13.94a12.833,12.833,0,0,1,12.52-12.966A12.833,12.833,0,0,1,70.5-69.215Z",
    transform: "translate(-7.199 98.199)",
    fill: "#03a9f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1227",
    "data-name": "Group 1227",
    transform: "translate(22.531 56.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M28.772-95,1.094-89.119,4.631-68.914A29.72,29.72,0,0,0,20.15-47.6a55.44,55.44,0,0,0,8.622,3.493A55.423,55.423,0,0,0,37.393-47.6,29.689,29.689,0,0,0,52.913-68.914L56.45-89.119ZM41.594-75.1,26.738-60.248a2.765,2.765,0,0,1-1.857.752,2.435,2.435,0,0,1-1.857-.752l-7.03-6.986a2.642,2.642,0,0,1,0-3.714,2.642,2.642,0,0,1,3.714,0l5.129,5.173,13-13.043a2.642,2.642,0,0,1,3.714,0,2.684,2.684,0,0,1,.044,3.714Z",
    transform: "translate(-1.094 95)",
    fill: "#f6fcff"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2066",
    "data-name": "Group 2066",
    transform: "translate(36.972 63.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check-circle-fill",
    d: "M20.828,10.414A10.414,10.414,0,1,1,10.414,0,10.414,10.414,0,0,1,20.828,10.414ZM15.66,6.47a.976.976,0,0,0-1.406.029l-4.521,5.76L7.009,9.533a.976.976,0,0,0-1.38,1.38l3.444,3.446a.976.976,0,0,0,1.4-.026l5.2-6.5a.976.976,0,0,0-.013-1.367Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check-circle-fill-2",
    "data-name": "check-circle-fill",
    d: "M20.828,10.414A10.414,10.414,0,1,1,10.414,0,10.414,10.414,0,0,1,20.828,10.414ZM15.66,6.47a.976.976,0,0,0-1.406.029l-4.521,5.76L7.009,9.533a.976.976,0,0,0-1.38,1.38l3.444,3.446a.976.976,0,0,0,1.4-.026l5.2-6.5a.976.976,0,0,0-.013-1.367Z",
    transform: "translate(0 36.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check-circle-fill-3",
    "data-name": "check-circle-fill",
    d: "M20.828,10.414A10.414,10.414,0,1,1,10.414,0,10.414,10.414,0,0,1,20.828,10.414ZM15.66,6.47a.976.976,0,0,0-1.406.029l-4.521,5.76L7.009,9.533a.976.976,0,0,0-1.38,1.38l3.444,3.446a.976.976,0,0,0,1.4-.026l5.2-6.5a.976.976,0,0,0-.013-1.367Z",
    transform: "translate(0 72.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2065",
    "data-name": "Group 2065",
    transform: "translate(36.878 10.401)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x2: 51.21,
    transform: "translate(1.302 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x2: 52.512,
    transform: "translate(0 37.464)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x2: 52.512,
    transform: "translate(0 74.929)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2290",
    "data-name": "Group 2290",
    transform: "translate(64.951 206.669)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_508",
    "data-name": "Ellipse 508",
    cx: 82.666,
    cy: 5.905,
    rx: 82.666,
    ry: 5.905,
    transform: "translate(0 35.427)",
    fill: "#2f2e40",
    opacity: 0.284
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1868",
    "data-name": "Rectangle 1868",
    width: 94.476,
    height: 35.429,
    transform: "translate(35.43)",
    fill: "#b5b9bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1869",
    "data-name": "Rectangle 1869",
    width: 141.714,
    height: 17.714,
    transform: "translate(11.811 23.617)",
    fill: "#b5b9bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1870",
    "data-name": "Rectangle 1870",
    width: 94.476,
    height: 5.905,
    transform: "translate(35.43 11.81)",
    fill: "#2f2e40",
    opacity: 0.115
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectionPlan);
export default __webpack_public_path__ + "static/media/protection-plan.b28e05c227a828f3225de000a9e43ab2.svg";
export { ForwardRef as ReactComponent };